class ProgressRingController {
    constructor() {
        "ngInject";
    }

    $onInit() {
        // Set defaults
        this.size = parseInt(this.size) || 120;
        this.strokeWidth = parseInt(this.strokeWidth) || 8;
        this.color = this.color || '#27ae60';
        this.bgColor = this.bgColor || '#e0e0e0';
        this.showPercentage = this.showPercentage !== false;
        this.showValues = this.showValues !== false;

        // Calculate radius (size / 2 - strokeWidth to account for stroke)
        this.radius = (this.size / 2) - (this.strokeWidth / 2);
        this.center = this.size / 2;
    }

    getProgressPercentage() {
        const current = parseFloat(this.current) || 0;
        const total = parseFloat(this.total) || 0;
        if (total === 0) return 0;
        return Math.min(100, (current / total) * 100);
    }

    getCircumference() {
        // 2 * π * radius
        return 2 * Math.PI * this.radius;
    }

    getStrokeDashoffset() {
        const percentage = this.getProgressPercentage();
        const circumference = this.getCircumference();
        // Calculate offset: circumference - (percentage / 100 * circumference)
        return circumference - (percentage / 100 * circumference);
    }

    getCurrentValue() {
        return parseFloat(this.current) || 0;
    }

    getTotalValue() {
        return parseFloat(this.total) || 0;
    }
}

export default ProgressRingController;




// WEBPACK FOOTER //
// ./client/common/directives/progress-ring/progress-ring.controller.js